import React from 'react';
import {useIntl} from 'react-intl';
import GenericModal from '../generic_modal';
import {BUTTON_COLOR, BUTTON_STYLE} from '../../../constants';
import Util from '../../../forecast-app/shared/util/util';
import CreateSavedReportMutation from '../../../mutations/create_saved_report_mutation';
import Moment from 'moment';
import {withRouter} from 'react-router-dom';
import {getEyeApplied} from './create-new-report-util';
import {getSavedReportURLByReportType} from '../../../components/insights/saved_report_util';

const createNewReportModal = ({closeModal, reportTypes, modules, availableFeatureFlags, history}) => {
	const coolAnimals = ['Albatross', 'Alpaca', 'Beaver', 'Cheetah', 'Dinosaur', 'Flamingo', 'Gazelle', 'Hippopotamus', 'Kangaroo', 'Koala', 'Lemur', 'Octopus', 'Penguin', 'Raccon'];
	const onSuccess = response => {
		closeModal();
		const reportResponse = response.createSavedReport.savedReport.node;
		history.push(getSavedReportURLByReportType(reportResponse.type, reportResponse.id));
	};

	const types = reportTypes.map(reportType => (
		<span
			onClick={() => {
				Util.CommitMutation(
					CreateSavedReportMutation,
					{
						name: reportType + ', ' + coolAnimals[Math.floor(Math.random() * coolAnimals.length)],
						type: reportType,
						eyeApplied: JSON.stringify(getEyeApplied(reportType, module)),
						startDate: Moment().startOf('month').format('YYYY-MM-DD'),
						endDate: Moment().endOf('month').format('YYYY-MM-DD'),
						filterApplied: JSON.stringify(null),
					},
					onSuccess
				);
			}}
		>
			{reportType}
		</span>
	));
	const intl = useIntl();

	const content = <div className="create-report-types">{types}</div>;

	return (
		<GenericModal
			closeModal={closeModal}
			buttons={[
				{
					text: intl.formatMessage({id: 'common.cancel'}),
					style: BUTTON_STYLE.FILLED,
					color: BUTTON_COLOR.WHITE,
				},
			]}
			headerText={'Choose Report Type'}
			content={content}
		/>
	);
};

export default withRouter(createNewReportModal);
